<template>
  <div>
    <v-card>
      <v-card-title class="secondary">
        <span class="subtitle white--text">Survey Details</span>
        <v-spacer></v-spacer>
        <v-icon class="white--text" @click="orgDialoge()">mdi-close</v-icon>
      </v-card-title>
      <v-container>
        <v-row class="ml-3">
          <v-col cols="12" sm="6" md="3">
            <div>
              <b>Survey Type:</b>
              {{ survey_type }}
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <div>
              <b>Cause Of Loss:</b>
              {{ causeOfloss }}
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <div>
              <b>REF Number:</b>
              {{ refenceNumber }}
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <div>
              <b>Claim Name:</b>
              {{ claimname }}
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <div>
              <b>Mobile Number:</b>
              {{ mobileNumber }}
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="5">
            <div>
              <b>Surveyor Email:</b>
              {{ surveyEmail }}
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="1" v-if="serveyDetailsArray[0].pdf_url != ''">
            <v-btn color="success" @click="downloadPdf()" tile large icon>
              <v-icon>picture_as_pdf</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-container>
        <v-row>
          <v-col cols="12" sm="6">
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="serveyDetailsArray"
                item-key="name"
                class="elevation-1"
                :items-per-page="10"
                :loading="tableLoading"
                dense
                @click:row="handleClick"
              >
                <template v-slot:item.surveyor_name="{ item }">
                  <span
                    class="cursor-pointer hyperlinkedText"
                    @click="handleClick(item)"
                  >{{ item.surveyor_name }}</span>
                </template>
              </v-data-table>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card v-if="serveyorcrd == true">
              <v-tabs v-model="tab" height="25px" fixed-tabs>
                <v-tab name="movies3">Comments</v-tab>
                <v-tab name="movies1">Photos</v-tab>
                <v-tab name="movies2">Assessment</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab" fluid class="mt-2">
                <v-tab-item name="movies3">
                  <SurveryComments :commentsServior="commentsServior" :callSummery="callSummery" />
                </v-tab-item>
                <v-tab-item name="movies1">
                  <v-card elevation="0">
                    <v-list dense>
                      <v-list-item v-if="photosForSurvey.length==0">
                        <v-list-item-content>No Data Available</v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-list dense>
                      <v-list-item
                        v-for="(item, index) in photosForSurvey"
                        :key="index"
                        @click.stop
                      >
                        <v-list-item-content>
                          <!-- <v-list-item-title v-if="photosForSurvey == null">No Photo</v-list-item-title> -->
                          <v-list-item-title>{{item.uploadedon}}</v-list-item-title>
                          <v-img :src="item.mediaurl" aspect-ratio="1.7"></v-img>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-tab-item>
                <v-tab-item name="movies2">
                  <ServeyorResponse :dialogData="dialogData" />
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-snackbar
      v-model="alertPositive"
      color="secondary"
      :timeout="timeout"
      bottom="bottom"
    >{{ text }}</v-snackbar>
    <v-snackbar
      v-model="alertNegetive"
      color="primary"
      :timeout="timeout"
      multi-line="multi-line"
      bottom="bottom"
    >{{ text }}</v-snackbar>
  </div>
</template>
<script>
import ServeyorResponse from "../views/ServeyorResponse.vue";
import SurveryComments from "../views/SurveryComments.vue";
import axios from "axios";
export default {
  components: {
    ServeyorResponse,
    SurveryComments
  },
  props: ["serveyDetailsArray", "serveId"],
  created: function() {
    console.log("llllllll", this.serveyDetailsArray[0]);
    console.log(this.serveId); //prints out an empty string
    this.getdataCommonData();
  },

  data() {
    return {
      surveyPdf_url: "",
      tab: null,
      items: [
        { tab: "Photos", content: "Tab 1 Content" },
        { tab: "Survey response", content: "Tab 2 Content" }
      ],
      text: "",
      loading: false,
      tableLoading: false,
      photosForSurvey: "",
      commentsServior: "",
      timeout: 1700,
      serveyTittle: "",
      survey_type: "",
      mobileNumber: "",
      causeOfloss: "",
      claimname: "",
      refenceNumber: "",
      surveyEmail: "",
      alertPositive: false,
      alertNegetive: false,
      dialogData: [],
      surveyname: "",
      serveyorcrd: false,
      itemsAraayOfsurveyid: [],
      serveyorNotes: "",
      serviorName: "",
      callSummery: "",
      headers: [
        {
          text: "Surveyor Name",
          value: "surveyor_name"
        },
        { text: "Submitted On", value: "submitted_on" }
      ]
    };
  },
  methods: {
    async downloadPdf() {
      if (this.serveyDetailsArray[0].pdf_url != "") {
        window.open(this.serveyDetailsArray[0].pdf_url);
      } else {
        this.alertNegetive = true;
        this.text = "No PDF";
      }
    },
    async getAllPhotosForSurveyBySurveyid(survey_id) {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "GetAllPhotos_getAllPhotosForSurveyBySurveyid",
        input: {
          surveyid: survey_id
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.photosForSurvey = res.data.data.data;
        var self = this;
        self.photosForSurvey.forEach(function(element) {
          element.uploadedon = new Date(element.uploadedon).toLocaleString();
        });
        console.log("photosForSurvey", this.photosForSurvey);
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    async getAllCallSummeryForSurvery(survey_id) {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "GetComments_getAllCommentsForSurveryPortal",
        input: {
          surveyid: survey_id,
          typeOfcomment: 2
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.callSummery = res.data.data.data;
        var self = this;
        self.callSummery.forEach(function(element) {
          element.commenton = new Date(element.commenton).toLocaleString();
        });
        console.log("callSummery", this.callSummery);
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    async getAllCommentsForSurvery(survey_id) {
      this.serveyorcrd = true;

      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "GetComments_getAllCommentsForSurveryPortal",
        input: {
          surveyid: survey_id,
          typeOfcomment: 1
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.commentsServior = res.data.data.data;
        var self = this;
        self.commentsServior.forEach(function(element) {
          element.commenton = new Date(element.commenton).toLocaleString();
        });
        console.log("siteVisit", this.commentsServior);
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");

      return `${month}/${day}/${year}`;
    },
    getdataCommonData() {
      console.log("serveyDetailsArray", this.serveyDetailsArray);
      this.serveyTittle = this.serveyDetailsArray[0].survey_title;
      // this.serveydescription = this.serveyDetailsArray[0].survery_description;
      this.refenceNumber = this.serveyDetailsArray[0].survey_referencenumber;
      this.mobileNumber = this.serveyDetailsArray[0].survey_mobilenumber;
      this.survey_type = this.serveyDetailsArray[0].survey_type;
      this.claimname =
        this.serveyDetailsArray[0].survey_claimed_firstname +
        " " +
        this.serveyDetailsArray[0].survey_claimed_lastname;
      this.causeOfloss = this.serveyDetailsArray[0].survey_causeofloss;
      this.surveyEmail = this.serveyDetailsArray[0].surveyor_email;

      this.surveyPdf_url = this.serveyDetailsArray[0].pdf_url;
      this.handleClick(this.serveyDetailsArray[0]);
    },
    handleClick(value) {
      console.log("70");
      this.tableLoading = true;
      this.loading = true;
      this.serveyorcrd = true;
      this.dialogData = [];
      this.photosForSurvey = [];
      this.commentsServior = [];
      this.callSummery = [];
      this.getAllCommentsForSurvery(value.survey_id);
      this.getAllCallSummeryForSurvery(value.survey_id);
      this.getAllPhotosForSurveyBySurveyid(value.survey_id);
      this.dialogData = value.survey_response;
      this.dialogData = JSON.parse(value.survey_response.replace(/\\/g, ""));

      var self = this;
      self.dialogData.forEach(function(element) {
        if (element.type == "yes_no" && element.answer == "YES") {
          element.value = "Yes";
        }
        if (element.type == "yes_no" && element.answer == "No") {
          element.value = "No";
        }
      });
      this.tableLoading = false;
      this.loading = false;
    },
    orgDialoge() {
      this.dialogData = [];
      this.photosForSurvey = [];
      this.commentsServior = [];
      this.callSummery = [];
      this.$emit("backEdit");
    },
    onclickback() {
      this.serviorStatus = true;
    },
    createPacks(item) {
      //  console.log(item);
      this.itemsAraayOfsurveyid = item;
      this.serviorName = item.serveyorname;
      this.serviorStatus = false;
    }
  }
};
</script>
<style scoped>
.hyperlinkedText {
  color: #4b9465;
  text-decoration: underline;
}
</style>

